function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import borders from "./borders";
import breakpoints from "./breakpoints";
import colors from "./colors";
import radii from "./radius";
import shadows from "./shadows";
import sizes from "./sizes";
import { spacing } from "./spacing";
import transition from "./transition";
import typography from "./typography";
import zIndices from "./z-index";
import blur from "./blur";

var foundations = _extends({
  breakpoints,
  zIndices,
  radii,
  blur,
  colors
}, typography, {
  sizes,
  shadows,
  space: spacing,
  borders,
  transition
});

export default foundations;
//# sourceMappingURL=index.js.map